var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 56,
    rx: 8,
    fill: "#ccc",
    stroke: "#333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 32,
    height: 10,
    rx: 2,
    fill: "#222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 16,
    height: 6,
    rx: 1,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 12,
    height: 6,
    rx: 1,
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.ac0d08a6384ac2cc1314af35eff1d2b3.svg";
export { ForwardRef as ReactComponent };